import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_describe_how_workers'

export const dataPointDefinition = {
  retracedId: 'yes_describe_how_workers',
  name: "If yes, please describe how workers' representatives and/or workers were involved in the self/joint-assessment process:",
  description:
    "Please indicate the roles of the workers' representatives or workers who were involved in the self/joint-assessment (do not provide names, but rather indicate their representative roles in the facility, e.g., trade union officials, workers' representatives on the xxx committee) and/or the role of th",
  meta: {
    slcpMeta: {
      key: 'fp-bas-8f',
      number: 'FP-BAS-27.3',
      masterType: 'Follow-up',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-bas-8f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27220,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
